<template>
  <div class="datepicker-custom">
    <Datepicker
      id="datepicker-full-width"
      v-model="value"
      format="dd/MM/isSearchyyyy"
      class="mb-2"
    ></Datepicker>
    <div id="datepicker-time" class="p-relative">
      <b-form-timepicker v-model="hour" locale="en"></b-form-timepicker>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import "vue-scroll-picker/dist/style.css";
import { ScrollPicker, ScrollPickerGroup } from "vue-scroll-picker";
export default {
  components: {
    Datepicker,
    ScrollPicker,
  },
  data() {
    return {
      hours: [
        { value: 0, name: "0KG" },
        { value: 10, name: "10KG" },
        { value: 20, name: "20KG" },
        { value: 30, name: "30KG" },
        { value: 40, name: "40KG" },
        { value: 50, name: "50KG" },
        { value: 60, name: "60KG" },
        { value: 70, name: "70KG" },
        { value: 80, name: "80KG" },
        { value: 90, name: "90KG" },
        { value: 100, name: "100KG" },
      ],

      date: null,
      hour: null,
      minute: null,
    };
  },
  created() {},
};
</script>
<style lang="scss">
#datepicker-full-width {
  height: 35px;
  width: 100%;
  border-radius: 5px;
  border: none !important;
  padding: 6px 10px;
  &:hover,
  &:focus,
  &:focus-visible {
    cursor: pointer;
    border: none !important;
    outline: none !important;
    border-radius: 5px;
  }
}
.vdp-datepicker__calendar {
  width: 100% !important;
  top: 130% !important;
  border-radius: 5px;
  border: none !important;
  .selected {
    background-color: #28938d !important;
    border-radius: 5px;

    color: #fff !important;
  }
}
.datepicker-custom {
  display: grid;
  grid-gap: 1%;
  grid-template-columns: 64% 35%;
}
.datepicker-time-input {
  border: none !important;
  height: 35px !important;
  border-radius: 5px;
  width: 100%;
  &:hover,
  &:focus,
  &:focus-visible {
    cursor: pointer;
    border: none !important;
    outline: none !important;
    border-radius: 5px;
  }
}
.picker-group {
  display: flex;
}

.time-v2 {
  .top {
    display: none;
  }
  .bottom {
    background: none !important;
  }
}

</style>
